import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=1b22fb40&scoped=true&"
import script from "./ErrorComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorComponent.vue?vue&type=script&lang=js&"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=1b22fb40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22fb40",
  null
  
)

export default component.exports